import Vue from 'vue';
import VueI18n from 'vue-i18n';

import * as errorCodes from './classes/error-codes';

Vue.use(VueI18n);

// Extend Vue18n

VueI18n.prototype._pluralIndex = function _pluralIndex(_locale, choice) {
  choice = parseInt(choice);
  choice = typeof choice === 'number' && isNaN(choice) ? 1 : choice; // Fallback to singular.

  // Extract the ISO 639 language code. The ISO 639 standard defines
  // two-letter codes for many languages, and three-letter codes for
  // more rarely used languages.
  // https://www.gnu.org/software/gettext/manual/html_node/Language-Codes.html#Language-Codes
  if (_locale.length > 2 && _locale !== 'pt_BR') {
    _locale = _locale.split('_')[0];
  }

  switch (_locale) {
    case 'ay': // Aymará
    case 'bo': // Tibetan
    case 'cgg': // Chiga
    case 'dz': // Dzongkha
    case 'fa': // Persian
    case 'id': // Indonesian
    case 'ja': // Japanese
    case 'jbo': // Lojban
    case 'ka': // Georgian
    case 'kk': // Kazakh
    case 'km': // Khmer
    case 'ko': // Korean
    case 'ky': // Kyrgyz
    case 'lo': // Lao
    case 'ms': // Malay
    case 'my': // Burmese
    case 'sah': // Yakut
    case 'su': // Sundanese
    case 'th': // Thai
    case 'tt': // Tatar
    case 'ug': // Uyghur
    case 'vi': // Vietnamese
    case 'wo': // Wolof
    case 'zh': // Chinese
      // 1 form
      return 0;
    case 'is': // Icelandic
      // 2 forms
      return choice % 10 !== 1 || choice % 100 === 11 ? 1 : 0;
    case 'jv': // Javanese
      // 2 forms
      return choice !== 0 ? 1 : 0;
    case 'mk': // Macedonian
      // 2 forms
      return choice === 1 || choice % 10 === 1 ? 0 : 1;
    case 'ach': // Acholi
    case 'ak': // Akan
    case 'am': // Amharic
    case 'arn': // Mapudungun
    case 'br': // Breton
    case 'fil': // Filipino
    case 'fr': // French
    case 'gun': // Gun
    case 'ln': // Lingala
    case 'mfe': // Mauritian Creole
    case 'mg': // Malagasy
    case 'mi': // Maori
    case 'oc': // Occitan
    case 'pt_BR': // Brazilian Portuguese
    case 'tg': // Tajik
    case 'ti': // Tigrinya
    case 'tr': // Turkish
    case 'uz': // Uzbek
    case 'wa': // Walloon
    /* eslint-disable */
    /* Disable "Duplicate case label" because there are 2 forms of Chinese plurals */
    case 'zh': // Chinese
      /* eslint-enable */
      // 2 forms
      return choice > 1 ? 1 : 0;
    case 'lv': // Latvian
      // 3 forms
      return choice % 10 === 1 && choice % 100 !== 11 ? 0 : choice !== 0 ? 1 : 2;
    case 'lt': // Lithuanian
      // 3 forms
      return choice % 10 === 1 && choice % 100 !== 11
        ? 0
        : choice % 10 >= 2 && (choice % 100 < 10 || choice % 100 >= 20)
        ? 1
        : 2;
    case 'be': // Belarusian
    case 'bs': // Bosnian
    case 'hr': // Croatian
    case 'ru': // Russian
    case 'sr': // Serbian
    case 'uk': // Ukrainian
      // 3 forms
      return choice % 10 === 1 && choice % 100 !== 11
        ? 0
        : choice % 10 >= 2 && choice % 10 <= 4 && (choice % 100 < 10 || choice % 100 >= 20)
        ? 1
        : 2;
    case 'mnk': // Mandinka
      // 3 forms
      return choice === 0 ? 0 : choice === 1 ? 1 : 2;
    case 'ro': // Romanian
      // 3 forms
      return choice === 1 ? 0 : choice === 0 || (choice % 100 > 0 && choice % 100 < 20) ? 1 : 2;
    case 'pl': // Polish
      // 3 forms
      return choice === 1
        ? 0
        : choice % 10 >= 2 && choice % 10 <= 4 && (choice % 100 < 10 || choice % 100 >= 20)
        ? 1
        : 2;
    case 'cs': // Czech
    case 'sk': // Slovak
      // 3 forms
      return choice === 1 ? 0 : choice >= 2 && choice <= 4 ? 1 : 2;
    case 'csb': // Kashubian
      // 3 forms
      return choice === 1
        ? 0
        : choice % 10 >= 2 && choice % 10 <= 4 && (choice % 100 < 10 || choice % 100 >= 20)
        ? 1
        : 2;
    case 'sl': // Slovenian
      // 4 forms
      return choice % 100 === 1
        ? 0
        : choice % 100 === 2
        ? 1
        : choice % 100 === 3 || choice % 100 === 4
        ? 2
        : 3;
    case 'mt': // Maltese
      // 4 forms
      return choice === 1
        ? 0
        : choice === 0 || (choice % 100 > 1 && choice % 100 < 11)
        ? 1
        : choice % 100 > 10 && choice % 100 < 20
        ? 2
        : 3;
    case 'gd': // Scottish Gaelic
      // 4 forms
      return choice === 1 || choice === 11
        ? 0
        : choice === 2 || choice === 12
        ? 1
        : choice > 2 && choice < 20
        ? 2
        : 3;
    case 'cy': // Welsh
      // 4 forms
      return choice === 1 ? 0 : choice === 2 ? 1 : choice !== 8 && choice !== 11 ? 2 : 3;
    case 'kw': // Cornish
      // 4 forms
      return choice === 1 ? 0 : choice === 2 ? 1 : choice === 3 ? 2 : 3;
    case 'ga': // Irish
      // 5 forms
      return choice === 1
        ? 0
        : choice === 2
        ? 1
        : choice > 2 && choice < 7
        ? 2
        : choice > 6 && choice < 11
        ? 3
        : 4;
    case 'ar': // Arabic
      // 6 forms
      return choice === 0
        ? 0
        : choice === 1
        ? 1
        : choice === 2
        ? 2
        : choice % 100 >= 3 && choice % 100 <= 10
        ? 3
        : choice % 100 >= 11
        ? 4
        : 5;
    default: // Everything else
      return choice !== 1 ? 1 : 0;
  }
};

VueI18n.prototype._tc = function _tc(key, _locale, messages, host, choice) {
  const values = [];
  let len = arguments.length - 5;

  while (len-- > 0) {
    values[len] = arguments[len + 5];
  }

  if (!key) {
    return '';
  }

  if (choice === undefined) {
    choice = 1;
  }

  const pluralIndex = this._pluralIndex(_locale, choice);

  const pluralArr = this.t(key, _locale, messages, host).split('|');

  const m = {};
  m[_locale] = {};
  m[_locale][key] = pluralArr[pluralIndex];

  return this._t(key, _locale, m, null, ...values);
};

// Create default object

const translationRU = {};

translationRU[errorCodes.ERROR_HTTP_404] = 'Ошибка сервера';
translationRU[errorCodes.ERROR_UNKNOWN_ERROR] = 'Неизвестная ошибка';
translationRU[errorCodes.ERROR_USER_EXIST] = 'Пользователь существует';
translationRU[errorCodes.ERROR_USER_DOES_NOT_EXIST] = 'Пользователь не существует';
translationRU[errorCodes.ERROR_USER_WITH_PHONE_NUMBER_EXIST] =
  'Пользователь с этим номером телефона уже зарегистрирован';
translationRU[errorCodes.ERROR_USER_WITH_PHONE_NUMBER_DOES_NOT_EXIST] =
  'Пользователь с этим номером телефона не зарегистрирован';
translationRU[errorCodes.ERROR_USER_WITH_EMAIL_EXIST] =
  'Пользователь с этим email уже зарегистрирован';
translationRU[errorCodes.ERROR_USER_WITH_EMAIL_DOES_NOT_EXIST] =
  'Пользователь с этим email не зарегистрирован';
translationRU[errorCodes.ERROR_USER_AUTHORIZED] = 'Пользователь уже авторизован';
translationRU[errorCodes.ERROR_USER_IS_NOT_AUTHORIZED] = 'Пользователь не авторизован';
translationRU[errorCodes.ERROR_PHONE_NUMBER_IS_NOT_VALID] = 'Неверный номер телефона';
translationRU[errorCodes.ERROR_PHONE_NUMBER_IS_NOT_CONFIRMED] = 'Номер телефона не подтвержден';
translationRU[errorCodes.ERROR_PHONE_NUMBER_DOES_NOT_EXIST] = 'Номер телефона не существует';
translationRU[errorCodes.ERROR_EMAIL_DOES_NOT_EXIST] = 'Email не существует';
translationRU[errorCodes.ERROR_EMAIL_IS_NOT_CONFIRMED] = 'Email не подтвержден';
translationRU[errorCodes.ERROR_PASSWORD_IS_NOT_VALID] = 'Неверный пароль';
translationRU[errorCodes.ERROR_USER_TYPE_IS_NOT_VALID] = 'Неверный тип пользователя';
translationRU[errorCodes.ERROR_SECURITY_CODE_IS_NOT_VALID] = 'Неверный код безопасности';
translationRU[errorCodes.ERROR_SECURITY_TOKEN_DOES_NOT_EXIST] = 'Неверный код безопасности';
translationRU[errorCodes.ERROR_REGISTRATION_FAILED] = 'Ошибка регистрации';
translationRU[errorCodes.ERROR_INN_IS_NOT_VALID] = 'Неверный ИНН';
translationRU[errorCodes.ERROR_COMPANY_IS_NOT_ACTIVE] = 'Введенный ИНН не активен';

translationRU.error_security_code_required = 'Нужно указать код безопасности';

export default new VueI18n({
  locale: 'ru',
  messages: {
    ru: translationRU,
  },
  silentTranslationWarn: true,
});
